import Vue from "vue";
import assigneesDB from "@mobile/db/assignees";

export default {
    assigneesRetrieved: (state, assignees) => {
        assigneesDB.clear()
        assigneesDB.add(assignees)
        Vue.set(state, "assignees", assignees);
    },
    assigneesOfflineRetrieved: (state, assignees) => {
        Vue.set(state, "assignees", assignees);
    }
};
